<style>
.bg-primary {
  --bs-bg-opacity: 1;
  background-color: #add26b !important;
}
#footer {
	position: fixed;
	bottom: 0;
	width: 100%;
	/* Height of the footer */
	height: 64px;
	z-index: 2;
}
</style>
<template>
	<!--Here is the layout of a page, including the header-->
	<div id="app">
		<!-- navbar -->
		<!--<b-navbar toggleable="lg" type="dark" variant="info" bg="red">-->
		<b-navbar toggleable="lg" type="dark" variant="primary">
			<b-navbar-brand margin-left=30px margin-right=30px><b>NetFlow3D</b></b-navbar-brand>
			
			<b-navbar-brand to="/">Home</b-navbar-brand>
			<b-navbar-brand to="/custom">Tool</b-navbar-brand>
			<b-navbar-brand to="/downloads">Downloads</b-navbar-brand>
			<b-navbar-brand to="/about">About</b-navbar-brand>

			
		</b-navbar>
		<!-- content -->
		<!-- <b-container fluid class="content" style="padding:0px;"> -->
			<!-- <b-row class="text-center mr-0"> -->
				<!-- <b-col class="left-side" cols="1" style="background:gainsboro;"></b-col> -->
				<!-- <b-col class="center" cols="10"> -->
					<router-view />
				<!-- </b-col> -->
				<!-- <b-col class="right-side" cols="1" style="background:gainsboro;"></b-col> -->
			<!-- </b-row> -->
		<!-- </b-container> -->
		<customfooter />
	</div>
</template>

<script>
import customfooter from '@/view/Footer.vue';

export default {
	name: 'app',
	data() {
		return {
		}
	},
	components: {
		customfooter
	},	
	mounted() {
	},
	methods: {
	}
}
</script>

<style>
html, body { 
	width: 100%; 
	height: 100%; 
}

#app {
	font-family: 'Avenir', Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	//color: #ADC96B;
	color: #2c3e50;
}

</style>
